import PropTypes from "prop-types";
import { useRef } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import { Box,  AppBar, Toolbar, } from "@mui/material";
// hooks
import useOffSetTop from "../../hooks/useOffSetTop";

// utils
import { bgBlur } from "../../utils/cssStyles";
// config
import { HEADER } from "../../config-global";
// routes

// components
import Logo from "../../components/logo";


// ----------------------------------------------------------------------

const HeaderLogin = () => {
  const carouselRef = useRef(null);

  const theme = useTheme();



  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);
  return (
    <AppBar
      ref={carouselRef}
      color="transparent"
      sx={{
        position: "relative",
        width: "100%",
        height: "80px",
        paddingTop: "15px",
        paddingLeft: "10px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 3px rgba(0, 0, 0, 0.25)",
        overflow: "hidden",
        "@media (max-width: 600px)": {
          
            height: "80px",
          },
      }}
    >
      <Toolbar
      disableGutters
      sx={{
        height: {
          xs: HEADER.H_MOBILE,
          md: HEADER.H_MAIN_DESKTOP,
        },
        transition: theme.transitions.create(["height", "background-color"], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.shorter,
        }),
        ...(isOffset && {
          ...bgBlur({ color: theme.palette.background.default }),
          height: {
            md: HEADER.H_MAIN_DESKTOP - 16,
          },
        }),
      }}
      >
				<Logo sx={{ ml:2}}/>
      
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
};

// ----------------------------------------------------------------------

Shadow.propTypes = {
  sx: PropTypes.object,
};

function Shadow({ sx, ...other }) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        m: "auto",
        borderRadius: "50%",
        position: "absolute",
        width: `calc(100% - 48px)`,
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}

export default HeaderLogin;


 